<div class="title">
    <span>{{ 'translation:Calls' | i18next }}</span>
       <i id="close-btn-system-queue-dialog" class="close-icon" mat-button cdkFocusInitial [mat-dialog-close]="false" (click)="closeDialog()"></i>
</div>

<div class="dialog-content">
  <table class="full-width-table" *ngIf="items?.length; else noData">
    <thead>
      <tr class="mat-mdc-header-row" >
        <th class="left">{{ 'realtime:system_queue_name' | i18next }}</th>
        <th class="left-system-queue-col">{{ 'realtime:agentLogon' | i18next }}</th>
        <th class="right-system-queue-col">{{ 'realtime:agentInPause' | i18next }}</th>
      </tr>
    </thead>
    <tbody>
      <tr class="mat-mdc-row" *ngFor="let el of items">
        <td class="left">{{el.queueName | htmlDecode }}</td>
        <td class="left-system-queue-col text-right">
          {{ el.agentsLoggedIn ?? 0 }}
        </td>
        <td class="right-system-queue-col text-right">
          {{ el.agentsInPause ?? 0 }}
        </td>
      </tr>
    </tbody>
  </table>

  <ng-template #noData>
    <div class="no-items">{{ 'realtime:noResults' | i18next }}</div>
  </ng-template>
</div>



